module.exports = __webpack_public_path__ + "assets/img/e868-dz.svg";